
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://gsfaahduxroedojmfwge.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdzZmFhaGR1eHJvZWRvam1md2dlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEwODUyODgsImV4cCI6MjA4NjY2MTI4OH0.EBtIWPIk20ZO6vUmGK0y3dJhvOwhaWP8eNUzl7O37G0';

export const supabase = createClient(supabaseUrl, supabaseKey);
